import { morphSection } from '@theme/section-renderer';

/** Fetch native card markup with Shopify sorting across the whole collection. */
class VlabCatalog extends HTMLElement {
  connectedCallback() {
    if (this.dataset.resolved === 'true' || !this.dataset.url) return;
    this.controller?.abort();
    this.controller = new AbortController();
    this.refresh();
  }
  async refresh() {
    const controller = this.controller;
    let url = new URL(this.dataset.url, location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('sort_by', 'created-desc');
    url.searchParams.set('filter.v.availability', '1');
    const limit = Number(this.dataset.limit);
    const cards = [];
    const seen = new Set();
    const pages = new Set();
    let responseDocument;
    try {
      while (cards.length < limit && !pages.has(url.href)) {
        pages.add(url.href);
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.querySelector('vlab-catalog[data-resolved="true"]');
        responseDocument ??= doc;
        if (!result) return;
        for (const card of result.querySelectorAll('.vlab-products__item')) {
          if (!seen.has(card.dataset.productId)) { seen.add(card.dataset.productId); cards.push(card); }
          if (cards.length === limit) break;
        }
        if (!result.dataset.next) break;
        const next = new URL(result.dataset.next, url);
        if (next.origin !== location.origin || next.pathname !== url.pathname) return;
        next.searchParams.set('section_id', this.dataset.sectionId);
        next.searchParams.set('sort_by', 'created-desc');
        next.searchParams.set('filter.v.availability', '1');
        url = next;
      }
      if (!this.isConnected || controller.signal.aborted || this.controller !== controller) return;
      const result = responseDocument.querySelector('vlab-catalog');
      result.querySelector('.vlab-products').replaceChildren(...cards);
      result.hidden = cards.length === 0;
      await morphSection(this.dataset.sectionId, responseDocument.documentElement.outerHTML, { mode: 'full', injectStylesheet: true });
    } catch (error) {
      if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
    }
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('vlab-catalog')) customElements.define('vlab-catalog', VlabCatalog);
